import React from 'react';

import './App.css';

function App() {

  return (
    <div className="privacy-policy-container">
       <div className="logo-wrapper">
       <img src="/ic_launcher.png" alt="AIRMCT Logo" className="logo" />
      
      </div>
      <div className="logo-wrapper">
     
      <h1 >Privacy Policy for AIRMCT</h1>
      </div>
     
      <p><strong>Effective Date: 01 Aug 2025</strong> </p>
      <p><strong>Last Updated: 01 Aug 2025</strong> </p>

      <p>
        Scholaro India ("we", "our", "us") is committed to protecting the privacy
        of students, parents, teachers, and school administrators who use our
        application. This Privacy Policy explains how we collect, use, and
        protect your information.
      </p>

      <h2>Information We Collect</h2>
      <p>
        We may collect the following types of information:
      </p>
      <ul>
        <li>Student details such as name, class, roll number</li>
        <li>Parent and teacher contact information</li>
        <li>Attendance, homework, exam, and result data</li>
        <li>Fee and payment-related information</li>
        <li>App usage data for performance improvement</li>
      </ul>

      <h2>How We Use Information</h2>
      <p>
        The information collected is used only for school management purposes,
        including:
      </p>
      <ul>
        <li>Providing attendance, homework, notices, and results</li>
        <li>Processing fee payments securely</li>
        <li>Improving app functionality and user experience</li>
        <li>Communicating important school-related updates</li>
      </ul>

      <h2>Data Security</h2>
      <p>
        We use appropriate technical and organizational security measures to
        protect user data against unauthorized access, alteration, or misuse.
        Access to data is limited to authorized school personnel only.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not sell, trade, or rent personal information to third parties.
        Data may be shared only with the respective school authorities or when
        required by law.
      </p>

      <h2>Children’s Privacy</h2>
      <p>
        Scholaro India is designed for educational institutions. Student data is
        collected and managed under the responsibility of the school and with
        parental consent where applicable.
      </p>

      <h2>Third-Party Services</h2>
      <p>
        The app may use trusted third-party services for payments or analytics.
        These services follow their own privacy policies and comply with data
        protection standards.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted within the app or on this page.
      </p>

      <h2>Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <p>
        <strong>Email:</strong> edgebyteconsultancy@gmail.com
      </p>
    </div>
  );
};

export default App;
